import React from 'react';
import ComparisonModule from '../../ComparisonModule/ComparisonModule';
import './PaperTypeModal.less';

function PaperTypeModal({ hideProofBanner = false, overrides }) {
  return <ComparisonModule hideProofBanner={hideProofBanner} overrides={overrides} />;
}

export default PaperTypeModal;
